import React from 'react';

import { Box, Collapse, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DesktopDatePicker, DesktopTimePicker, LocalizationProvider, PickersDay, pickersDayClasses } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment'; 
// import 'moment/locale/en';
import 'moment/locale/fr';
import 'moment/locale/es';

import { setTime } from '../store/actions/profilActions';
import { useDebouncedCallback } from 'use-debounce';

export const ScheduleSelector = ({multimodal, timeFromUrl}) => {
  const {t, i18n} = useTranslation();
  const dispatch = useDispatch();
  
  const typeOfDate = useSelector(state => state.profils.type_date);
  const dateSelected = useSelector(state => state.profils.time); 


  
  // const handleTypeDate = evt => {
  //   dispatch(setTypeDate(evt.target.value));
  // };


  const handleSelectDate = useDebouncedCallback((value) => {
    dispatch(setTime(value));
  }, 500);


  const style = {
    container: {
      display: 'flex',
      justifyContent: 'center',
    },
    scheduleContainer: {
      display: 'flex',
      flex: 1,
      borderRadius: '.5em',
      paddingY: '1em'
    },
    contentContainer: {
      display: 'flex',
      width: '100%',
      paddingX: '1em'
    },
    dateContainer: {
      display: 'flex', 
      width: '60%',
    },
    hourContainer: {
      display: 'flex',
      width: '35%',
    },
    timeContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',

    },
    buttonStyle: {
      display: 'flex',
      textAlign: 'center',
      textTransform: 'none'
    },
    labelStyle: {
      fontStyle: 'normal',
      fontSize: '1.15em'
    }
  };

  const renderPickersDay = (pickersDayProps) => {
    return (
      <PickersDay {...pickersDayProps}
        sx={{
          [`&&.${pickersDayClasses.selected}`]: {
            textDecoration: 'underline'
          },
          [`&&.${pickersDayClasses.today}`]: {
            borderRadius: '.5em'
          }
        }} />
    );
  };


  if (moment.locale() !== i18n.language) {
    moment.locale(i18n.language);
  }

  if (timeFromUrl && timeFromUrl !== null) {
    handleSelectDate(moment(timeFromUrl));
  }
  
  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={i18n.language}>
      <Collapse in={multimodal}>
        <Box sx={style.container} data-cy='view-schedule'>
          <Box sx={style.scheduleContainer}>
            <Stack sx={style.contentContainer} direction='column' spacing={2}>
              <Box sx={style.timeContainer}>     
                <Box sx={style.dateContainer}> 
                  <DesktopDatePicker 
                    id='datePicker'
                    format='DD MMMM YYYY'
                    slots={{
                      day: renderPickersDay
                    }}
                    slotProps={{
                      textField: {
                        sx: {backgroundColor: '#FFFFFF'},
                        inputProps: {
                          'data-cy': 'datePicker-input',
                          'aria-describedby': 'datePicker'
                        }
                      },
                      openPickerButton: {
                        'data-cy': 'datePicker-button',
                        'aria-label': typeOfDate === 1 ? t('schedule.select-date-departure') : t('schedule.select-date-arrival')
                      },
                      desktopPaper: {
                        'data-cy': 'datePicker-select-paper'
                      },
                      nextIconButton: {
                        'data-cy': 'next-month-button',
                        'aria-label': t('schedule.next-month')
                      },
                      previousIconButton: {
                        'data-cy': 'previuos-month-button',
                        'aria-label': t('schedule.previous-month')
                      }
                    }}
                    onChange={handleSelectDate}
                    value={dateSelected} 
                    label={typeOfDate === 1 ? t('schedule.date-label-departure') : t('schedule.date-label-arrival')}
                  />
                </Box> 
                <Box sx={style.hourContainer}>
                  <DesktopTimePicker 
                    id='timePicker' 
                    ampm={false}  
                    value={dateSelected} 
                    slotProps={{
                      textField: {
                        sx: {backgroundColor: '#FFFFFF'},
                        inputProps: {
                          'data-cy': 'timePicker-input',
                          'aria-describedby': 'timePicker'
                        }
                      },
                      openPickerButton: {
                        'data-cy': 'timePicker-button',
                        'aria-label': typeOfDate === 1 ? t('schedule.select-time-departure') : t('schedule.select-time-arrival')
                      },
                      desktopPaper: {
                        'data-cy': 'timePicker-select-paper'
                      }
                    }}
                    label={typeOfDate === 1 ? t('schedule.time-label-departure') : t('schedule.time-label-arrival')}
                    onChange={handleSelectDate} 
                  />
                </Box>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Collapse>
    </LocalizationProvider>
  );
};